import { useEffect, useState } from 'react';
import { ArticleApi, EventAPI, ProjectApi, ShowsApi } from '../../../network';
import { links, translations } from '../../../utils/staticContent';
import HomePageCard from '../../components/HomePageCard';
import './style.scss';
import { ArticleModel, EventModel, ProjectModel, ShowModel } from '../../../network/rest/models';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';

function Home() {
    const [event, setEvent] = useState<EventModel | undefined>(undefined);
    const [article, setArticle] = useState<ArticleModel | undefined>(undefined);
    const [project, setProject] = useState<ProjectModel | undefined>(undefined);
    const [show, setShow] = useState<ShowModel | undefined>(undefined);

    useEffect(() => {
        const getData = async () => {
            try {
                await Promise.all([
                    getFirstEvent(),
                    getFirstArticle(),
                    getFirstProject(),
                    getFirstShow(),
                ]);
            } catch (e) {
                ApiErrorHandler(e, true);
            }
        };

        getData();
    }, []);

    async function getFirstEvent() {
        const response = await EventAPI.getEventsApiV1EventsGet({
            offset: 0,
            limit: 1,
        });
        if (response) {
            setEvent(response.events[0]);
        }
    }

    async function getFirstArticle() {
        const response = await ArticleApi.getArticlesApiV1ArticlesGet({
            offset: 0,
            limit: 1,
        });
        if (response) {
            setArticle(response.articles[0]);
        }
    }

    async function getFirstProject() {
        const response = await ProjectApi.getProjectsApiV1ProjectsGet({
            offset: 0,
            limit: 1,
        });
        if (response) {
            setProject(response.projects[0]);
        }
    }

    async function getFirstShow() {
        const response = await ShowsApi.getShowsApiV1ShowsGet({
            offset: 0,
            limit: 1,
        });
        if (response) {
            setShow(response.shows[0]);
        }
    }

    return (
        <div className="Home">
            {show ? (
                <HomePageCard
                    contentType={translations.shows}
                    cta={links.shows}
                    title={show.title}
                    imageSrc={show.fileUrl as unknown as string}
                />
            ) : null}
            {article ? (
                <HomePageCard
                    contentType={translations.articles}
                    cta={links.articles}
                    title={article.title}
                    imageSrc={article.fileUrl as unknown as string}
                />
            ) : null}
            {event ? (
                <HomePageCard
                    contentType={translations.events}
                    cta={links.events}
                    title={event.title}
                    imageSrc={event.fileUrl as unknown as string}
                />
            ) : null}
            {project ? (
                <HomePageCard
                    contentType={translations.projects}
                    cta={links.projects}
                    title={project.title}
                    imageSrc={project.fileUrl as unknown as string}
                />
            ) : null}
        </div>
    );
}

export default Home;
